<script lang="ts">
	export let hours: number | null;
	export let minutes: number | null;
</script>

<div class="flex gap-0.5 flex-items-baseline text-4">
	<span class="text-8 line-height-8 text-bold">{hours}</span> h
	{#if minutes !== null && minutes > 0}
		<span class="text-8 line-height-8 text-bold">{String(minutes).padStart(2, '0')}</span> min
	{/if}
</div>
